import { Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from '@common/services/ui/modal.service';
import { LoggingService } from '@common/services/utility/logging.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
})
export class ModalDialogComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() title: string;
  @Input() isCloseButtonVisible: boolean;
  @Input() isOverlayEnabled = true;
  @Input() isClosingOnOverlayClick = true;
  @Input() isAutoWidth = false;

  @Output() closed: EventEmitter<void> = new EventEmitter();

  private isDialogOpened: boolean;
  private readonly element: Element;
  private lastTarget: Element;

  constructor(
    private modalService: ModalService,
    private el: ElementRef<Element>,
    private loggingService: LoggingService,
  ) {
    this.title = '';
    this.isCloseButtonVisible = true;

    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      this.loggingService.error(
        { message: 'modal must have an id', name: 'ModalDialogComponent' },
        null,
        'ngOnInit',
        this.constructor.name,
      );
      return;
    }

    document.body.appendChild(this.element);
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  get isHeaderVisible(): boolean {
    return !!this.title || this.isCloseButtonVisible;
  }

  get isOpened(): boolean {
    return this.isDialogOpened;
  }

  set isOpened(value: boolean) {
    if (this.isDialogOpened === value) {
      return;
    }

    this.isDialogOpened = value;

    if (this.isDialogOpened) {
      document.body.classList.add('modal-dialog-open');
    } else {
      document.body.classList.remove('modal-dialog-open');
      this.closed.emit();
    }
  }

  onOverlayMouseDown(event: MouseEvent): void {
    if (!this.isClosingOnOverlayClick) {
      return;
    }
    this.lastTarget = event.target as Element;
  }

  onOverlayMouseUp(event: MouseEvent): void {
    if (!this.isClosingOnOverlayClick) {
      return;
    }
    const target = event.target as Element;
    const currentTarget = event.currentTarget as Element;

    if (this.lastTarget?.isSameNode(target) && currentTarget.isSameNode(target) && this.isOverlayEnabled) {
      this.close();
    }
    this.lastTarget = null;
  }

  open(): void {
    this.isOpened = true;
  }

  close(): void {
    this.isOpened = false;
  }
}
